<template>
    <div component="ProjectActorDialogListTable">
        <header>
            <div class="cell date">Date</div>
            <div class="cell name">PROJECT NAME</div>
            <div class="cell type">Type</div>
        </header>
        <section>
            <div v-bar class="vb">
                <div>
                    <div class="item" v-for="(item, index) in data" :key="index">
                        <div class="cell date">{{ getDateWithTime(item.date) }}</div>
                        <div class="cell name">{{ item.project.title }}</div>
                        <div class="cell type">{{ item.projectType.title }}</div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'ProjectActorDialogListTable',

    props: {
        data: {
            type: Array,
            required: true,
        },
    },

    methods: {
        getDateWithTime(date) {
            return `${moment(date).format('YYYY-DD-MM')}`;
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ProjectActorDialogListTable'] {
    height: 100%;
    width: 100%;
    padding: 25px;
    .flex-column;

    section {
        overflow-y: auto;
        height: 200px;
        flex-grow: 1;
    }

    .cell {
        padding: 5px 0;
        font-size: 13px;
        &.date {
            width: 90px;
        }

        &.name {
            flex: 1;
            padding: 5px 10px;
        }

        &.type {
            width: 90px;
            text-align: right;
        }
    }

    header {
        width: 100%;
        display: flex;
        text-transform: uppercase;
        font-weight: 900;
        border-bottom: 1px solid @black;

        .type {
            padding-right: 10px;
        }
    }

    .item {
        display: flex;
        .border-b;
    }
}
</style>
